
<template>
  <component :is="attrs_.is" v-bind="attrs_">
    <slot />
  </component>
</template>

<script>

export default {
  props: {
    to: {
      type: String,
      required: true
    }
  },
  computed: {
    attrs_() {
      const reg = /^(https?:|mailto:|tel:)/
      if (reg.test(this.to)) {
        return {
          is: 'a',
          href: this.to,
          target: '_blank',
          rel: 'noopener'
        }
      }
      return {
        is: 'router-link',
        to: this.to
      }
    }
  }
}
</script>
